import type { ReactNode } from 'react'

import { CardDescription, CardHeader } from '@/components/ui/card'
import { SectionTitle } from '@/components/ui/section-title'

/** Same title row as `EntityAboutSection` — `SectionTitle` + optional action, `pb-2` before body. */
export function ProfileStandingSectionHeader({
  title,
  description,
  action,
}: {
  title: string
  description?: string | null
  action?: ReactNode
}) {
  return (
    <CardHeader className="pb-2">
      <div className="flex min-h-8 w-full items-start justify-between gap-2">
        <SectionTitle>{title}</SectionTitle>
        {action}
      </div>
      {description ? <CardDescription>{description}</CardDescription> : null}
    </CardHeader>
  )
}
